import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getVerificationGroup3MasterReferenceData = createAsyncThunk(
  'stop/getVerificationGroup3MasterReferenceData',
  async (params) => {
    const { url, payload, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .post(url, payload, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });
    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const verificationGroup3MasterReferenceSlice = createSlice({
  name: 'stop/verificationGroup3MasterReferenceSlice',
  initialState: null,
  reducers: {
    resetVerificationGroup3MasterReference: () => null,
  },
  extraReducers: {
    [getVerificationGroup3MasterReferenceData.fulfilled]: (state, action) =>
      action.payload,
  },
});

export const { resetVerificationGroup3MasterReference } =
  verificationGroup3MasterReferenceSlice.actions;

export default verificationGroup3MasterReferenceSlice.reducer;
